import { createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../../utils/api";

export const fetchByDate = createAsyncThunk(
  "products/fetchByDate",
  async (date, { signal }) => {
    const products = await client(`store/products/?date=${date}`, { signal });
    if (!Array.isArray(products)) throw new Error("Invalid menu response");
    return products;
  }
);
